import { isLogin } from 'utils/token'
import Main from './Main'

const NoOfferAlert = () => {
  if (!isLogin()) return null
  return <Main />
}

export default NoOfferAlert
